import React from 'react'
import View from 'src/components/atoms/View'
import ConversationButton from 'src/components/atoms/ConversationButton'
interface Props {
  offerHashId: string
  children: React.ReactNode
}

const ConversationWrapper = ({ offerHashId, children }: Props): JSX.Element => {
  return (
    <View className="flex justify-end mt-4">
      <ConversationButton offerHashId={offerHashId}>{children}</ConversationButton>
    </View>
  )
}

export default ConversationWrapper
